"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveSpectrumRangesViewState = exports.defaultRangesViewState = void 0;
const ChartContext_1 = require("../context/ChartContext");
const useActiveSpectrum_1 = require("./useActiveSpectrum");
exports.defaultRangesViewState = {
    showPeaks: false,
    showMultiplicityTrees: false,
    showRangesIntegrals: false,
    showJGraph: false,
    displayingMode: 'spread',
};
function useActiveSpectrumRangesViewState() {
    const activeSpectrum = (0, useActiveSpectrum_1.useActiveSpectrum)();
    const { view: { ranges }, } = (0, ChartContext_1.useChartData)();
    if (activeSpectrum?.id && ranges[activeSpectrum?.id]) {
        return ranges[activeSpectrum?.id];
    }
    else {
        return exports.defaultRangesViewState;
    }
}
exports.useActiveSpectrumRangesViewState = useActiveSpectrumRangesViewState;
